const faqPage = () => {
    const faq = document.querySelector(".faq");
    function getElementDistance(elem) {
        let location = 0;
        if (elem.offsetParent) {
            do {
                location += elem.offsetTop;
                elem = elem.offsetParent;
            } while (elem);
        }
        return location >= 0 ? location : 0;
    };
    if (faq) {
        const faqList = faq.querySelector(".faq__right-list");
        const faqText = faq.querySelector(".faq__text");
        if (faqText) {
            const faqHeaders = faqText.querySelectorAll("h2");
            for (let i = 0; i < faqHeaders.length; i++) {
                faqHeaders[i].parentElement.id = "faq" + i;
                let listEl = document.createElement("a");
                let text = faqHeaders[i].innerText.toLowerCase();
                let firstLetter = text.match(/[a-zA-Z]/).index;
                text = text.replace(text[firstLetter], text[firstLetter].toUpperCase());
                listEl.innerText = text;
                listEl.href = "#" + faqHeaders[i].parentElement.id;
                listEl.dataset.hash = "#" + faqHeaders[i].parentElement.id;
                listEl.classList.add("faq__right-list-item");
                faqList.appendChild(listEl);
            }
            faqList.parentElement.classList.add("loaded");
        }
        window.addEventListener("scroll", function(e){
            let fromTop = window.scrollY;
            if (faqList) {
                let faqLinks = faqList.children;
                for (let i = 0; i < faqLinks.length; i++) {
                    let section = document.querySelector(faqLinks[i].dataset.hash);
                    if (fromTop >= getElementDistance(section) && fromTop <= getElementDistance(section) + section.offsetHeight) {
                        faqLinks[i].classList.add("current");
                    }
                    else {
                        faqLinks[i].classList.remove("current");
                    }
                }
            }
        });
    }
}

export default faqPage;
